import { render, staticRenderFns } from "./NewPacketKindBranch.vue?vue&type=template&id=4638e75c&"
import script from "./NewPacketKindBranch.vue?vue&type=script&lang=ts&"
export * from "./NewPacketKindBranch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports